import Dbm from "dbm";
import Website from "./jsapp/website/index.js";

Dbm.setupGlobalInstance();
Dbm.startup.setupLibrary();

Dbm.updater.webSetup();
Dbm.updater.setupEasingFunctions();

Dbm.graphapi.webclient.decode.fullSetup();
Dbm.utils.CompareFunctions.fullSetup();
Website.graphapi.decode.fullSetup();

Website.setup.setupGame();
Dbm.startup.runStartup();